import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { init } from "@telegram-apps/sdk-react";
import { QueryClient, QueryClientProvider } from "react-query";
import * as Sentry from "@sentry/browser";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { CLEANER_SENTRY_DSN } from "./config/config";
import { isTelegramWebApp } from "./utils";
import { notificationService } from "./notification-service";

if (CLEANER_SENTRY_DSN) {
  Sentry.init({ dsn: CLEANER_SENTRY_DSN });
}

if (isTelegramWebApp()) {
  init();
}

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

if (!isTelegramWebApp()) {
  serviceWorkerRegistration.register();
  notificationService.subscribeToPushEvents();
}

root.render(
  <div className="wrapper">
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </div>
);
